"use client";

import React from "react";

import type { ResourceComponent } from "../Resource/types";
import type { Url as UrlType } from "../../../../types/content";

import { getTweetId, isTweet, isVideo, isWikipedia } from "./utils";
import { TweetResource } from "./Tweet/Tweet";
import { ArticleVideo } from "./ArticleVideo/ArticleVideo";
import { ArticleLink } from "./ArticleLink/ArticleLink";
import { useTcfPermission } from "../../../../tcf/helpers";
import { WikipediaResource } from "./Wikipedia/Wikipedia";

const Url: ResourceComponent<UrlType> = ({
  resource,
  layoutType,
  isPremium,
  isGrouped,
  isFirst,
  isMainResource,
  isUserPremium,
  urlIndex,
}) => {
  const advertisingPermission = useTcfPermission("CMP:advertising");

  if (isTweet(resource) && advertisingPermission) {
    return (
      <TweetResource
        tweetId={getTweetId(resource.url)}
        layoutType={layoutType}
      />
    );
  }

  if (isWikipedia(resource)) {
    return (
      <WikipediaResource
        url={resource.url}
        label={resource.label}
        title={resource.title?.value}
        source={resource.source}
        text={resource.data?.custom_properties?.text}
        layoutType={layoutType}
      />
    );
  }

  if (isVideo(resource)) {
    return (
      <ArticleVideo
        resource={resource}
        layoutType={layoutType}
        isGrouped={isGrouped}
        isFirst={isFirst}
        isMainResource={isMainResource}
      />
    );
  }

  return (
    <ArticleLink
      resource={resource}
      layoutType={layoutType}
      isPremium={isPremium}
      isUserPremium={isUserPremium}
      urlIndex={urlIndex}
    />
  );
};

export { Url };
